export type UserAccountStatus = "Deleted" | "Disabled";

export function getUserAccountStatus(
  status?: string | null,
  enabled?: boolean | null,
): UserAccountStatus | undefined {
  if (status?.toUpperCase() === "DELETED") return "Deleted";
  if (status?.toUpperCase() === "DISABLED" || enabled === false)
    return "Disabled";
  return undefined;
}
